import type { CityConfig } from "../city-template/types";

export const mansfieldConfig: CityConfig = {
  city: "Mansfield",
  state: "Ohio",
  stateAbbr: "OH",
  slug: "mansfield",
  route: "/mansfield",
  title: "Emergency Passport Mansfield, OH — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency and expedited passport services in Mansfield, OH — as fast as 24 hours. Same-day courier processing available. A+ BBB rated, registered State Dept. courier serving Richland County and the surrounding area. Get your passport fast!",
  h1: "Emergency & Expedited Passport Services in Mansfield, OH",
  heroSubtitle: "Passport expired before your trip? Need an emergency passport in Mansfield? We help Richland County travelers get their expedited passports as quickly as 24 hours. A+ BBB rated. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Mansfield%20Ohio%20city%20skyline%20downtown%20street%20view%20historic%20architecture%20mid-Ohio%20city%20warm%20natural%20daylight%20professional%20cityscape%20photography%20with%20rich%20colors%20and%20clear%20sky%20vibrant%20urban%20scene&width=1800&height=700&seq=mansfield-hero-001&orientation=landscape",
  heroImageAlt: "Mansfield Ohio downtown cityscape",
  geoPosition: "40.7584;-82.5154",
  geoPlacename: "Mansfield, Ohio",
  lastModified: "2026-07-21",
  regionalAgency: {
    name: "Chicago Passport Agency",
    address: "230 S Dearborn St, Suite 380, Chicago, IL 60604",
    distance: "Located in downtown Chicago — approximately 350 miles from Mansfield via I-90",
  },
  nearbyCitiesZips: [
    { name: "Mansfield", zips: "44901–44907" },
    { name: "Ontario", zips: "44906" },
    { name: "Shelby", zips: "44875" },
    { name: "Lexington", zips: "44904" },
    { name: "Crestline", zips: "44827" },
    { name: "Galion", zips: "44833" },
    { name: "Ashland", zips: "44805" },
    { name: "Wooster", zips: "44691" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier submission for urgent Mansfield departures" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-user-line", title: "Dedicated Agent", desc: "A real person assigned to your case from start to finish" },
    { icon: "ri-global-line", title: "Richland County Coverage", desc: "Serving Mansfield, Ontario, Shelby, and surrounding areas" },
  ],
  internalLinks: [
    { name: "Expedited passport services in Cleveland, OH", route: "/cleveland" },
    { name: "Fast passport renewal in Columbus, OH", route: "/columbus-oh" },
    { name: "Emergency passport help in Akron, OH", route: "/akron" },
    { name: "Urgent passport services in Canton, OH", route: "/canton" },
    { name: "Same-day passport help in Toledo, OH", route: "/toledo" },
    { name: "Passport courier services in Dayton, OH", route: "/dayton" },
  ],
  fpcOfficeNote: "Fast Passport Center serves Mansfield remotely via secure courier. Our registered couriers hand-deliver your documents directly to U.S. Department of State processing facilities, achieving 24–48 hour turnaround for Richland County travelers.",
  fpcOfficeDistance: "Serving all of Richland County and surrounding mid-Ohio region",
  fpcOfficeAddress: "175 S Third St, Ste 200, Columbus, Ohio 43215",
  serviceAreaIntro: "From downtown Mansfield to Ontario, Shelby, and Lexington, Fast Passport Center serves the entire Richland County region and beyond.",
  nearbyCitiesIntro: "We serve all Mansfield neighborhoods and nearby communities including Ontario, Shelby, Lexington, Crestline, Galion, Ashland, and Wooster.",
  howItWorksIntro: "Most Mansfield travelers complete everything online and ship documents overnight to avoid the long drive to Chicago.",
  mistakesIntro: "Mansfield travelers often face a long drive to the Chicago Regional Passport Agency. Here are the most common mistakes that cause delays.",
  testimonialsIntro: "Richland County travelers trust us when their departure is days away.",
  faqIntro: "Have questions about expedited passports in Mansfield? Here are the most common ones we hear from Richland County travelers.",
  statePageRoute: "/states/ohio",
  statePageName: "Ohio",
  dmvWebsite: "https://www.bmv.ohio.gov",
  dmvLabel: "Ohio BMV — Official Website",
  vitalRecordsLinks: [
    { icon: "ri-user-heart-line", label: "Birth Certificates — Ohio Department of Health", desc: "Request certified Ohio birth certificates from the ODH Bureau of Vital Statistics. Available by mail, online, or in person at the Columbus office.", url: "https://odh.ohio.gov/know-our-programs/vital-statistics" },
    { icon: "ri-file-history-line", label: "Death Certificates — Ohio Department of Health", desc: "Obtain certified Ohio death certificates through ODH Vital Statistics. Mail, online, and in-person options available.", url: "https://odh.ohio.gov/know-our-programs/vital-statistics" },
    { icon: "ri-hearts-line", label: "Marriage Certificates — Richland County Probate Court", desc: "Marriage licenses and certified copies available through the Richland County Probate Judge at 50 Park Ave E, Mansfield, OH 44902.", url: "https://www.richlandcountyoh.us/probate-court" },
    { icon: "ri-file-copy-2-line", label: "Divorce Records — Richland County Clerk of Courts", desc: "Certified divorce decrees available from the Richland County Clerk of Courts at 50 Park Ave E, Mansfield, OH 44902.", url: "https://www.richlandcountyoh.us/clerk-of-courts" },
    { icon: "ri-global-line", label: "Order Online — VitalChek", desc: "Order Ohio birth, death, marriage, and divorce certificates online through VitalChek, the official partner of the Ohio Department of Health. Fastest online option.", url: "https://www.vitalchek.com/" },
  ],
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: [
        "Appointment required — no walk-ins allowed",
        "Life-or-death emergencies only",
        "Bereavement or medical crisis",
        "5+ hour drive to Chicago agency",
      ],
      highlight: false,
      emergency: true,
    },
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Predictable turnaround",
        "Ideal for upcoming trips",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Faster than self-service",
        "Good for planned travel",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates",
        "Not affected by government shutdowns",
      ],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: [
        "No courier access — standard mail only",
        "In-person clerk appointment required",
        "No document review — errors cause rejection",
        "No dedicated agent — you are on your own",
        "Updates only by physical mail",
        "Can't upgrade speed after submission",
      ],
      highlight: false,
      muted: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For travelers with immediate departure needs — as fast as 24 hours for urgent Mansfield international flights.",
      bullets: ["24–48 hour turnaround available", "Registered courier hand-delivery", "Flight verification support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for adults with a passport issued within the last 15 years at age 16 or older.",
      bullets: ["No clerk visit required for most", "Mail-in or courier options", "Lost passport replacement available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport",
      description: "First-time passport application guidance with acceptance clerk appointment support.",
      bullets: ["Acceptance facility locator", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Passport replacement with DS-64 form guidance and police report documentation.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement options"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 with parental consent and acceptance clerk support.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change",
      description: "Passport correction and name change service after marriage, divorce, or legal changes.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
    { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens." },
    { name: "New Passport", description: "First-time passport application assistance." },
    { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports." },
    { name: "Child Passport", description: "Passport services for minors under 16." },
    { name: "Name Change", description: "Passport correction and name change service." },
  ],
  testimonials: [
    {
      name: "Brian T.",
      location: "Mansfield, OH",
      rating: 5,
      text: "Had a last-minute business trip and my passport was expired. Fast Passport Center had my renewal ready in 4 days. Incredible service — kept me updated every day.",
      service: "Passport Renewal",
    },
    {
      name: "Carla M.",
      location: "Ontario, OH",
      rating: 5,
      text: "Needed an emergency passport and dreaded the drive to Chicago. Fast Passport Center handled everything remotely — got mine in 36 hours. Highly recommend!",
      service: "Emergency Passport",
    },
    {
      name: "Steve W.",
      location: "Shelby, OH",
      rating: 5,
      text: "International work trip came up with only 5 days notice. They got me a passport in 3 business days. Professional and worth every penny.",
      service: "Emergency Passport",
    },
    {
      name: "Lisa K.",
      location: "Lexington, OH",
      rating: 5,
      text: "My son needed a first-time passport for a school trip. Fast Passport Center guided us through every document and had it ready in 5 days.",
      service: "Child Passport",
    },
  ],
  facilities: [
    {
      id: "mansfield-1",
      name: "Mansfield Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "47 Park Ave W",
      city: "Mansfield",
      state: "OH",
      zip: "44902",
      phone: "(419) 756-6511",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Downtown Mansfield",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Main downtown facility. Call ahead for passport appointments.",
      icon: "ri-mail-line",
    },
    {
      id: "mansfield-2",
      name: "Ontario Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "1155 N Lexington-Springmill Rd",
      city: "Ontario",
      state: "OH",
      zip: "44906",
      phone: "(419) 529-2511",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "West Mansfield suburb",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Convenient for west-side Mansfield and Ontario residents. Ample parking.",
      icon: "ri-mail-line",
    },
    {
      id: "mansfield-3",
      name: "Shelby Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "60 N Gamble St",
      city: "Shelby",
      state: "OH",
      zip: "44875",
      phone: "(419) 347-2511",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "15 miles north of Mansfield",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves north Richland County residents. Call ahead for appointment.",
      icon: "ri-mail-line",
    },
    {
      id: "mansfield-4",
      name: "Richland County Clerk of Courts",
      type: "Court Clerk Passport Acceptance",
      address: "50 Park Ave E",
      city: "Mansfield",
      state: "OH",
      zip: "44902",
      phone: "(419) 774-5595",
      hours: "Mon–Fri: 8:00 AM – 4:00 PM",
      distance: "Richland County Courthouse, Downtown Mansfield",
      website: "https://www.richlandcountyoh.us/",
      websiteLabel: "Richland County",
      notes: "Alternative to post office for passport applications. Appointment recommended.",
      icon: "ri-government-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, limited slots", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — 5+ hour drive to Chicago", fpc: "No — ship from home or office" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "Guaranteed Timing", agency: "No — subject to availability", fpc: "Yes — contractual turnaround times" },
  ],
  mistakes: [
    {
      icon: "ri-image-line",
      title: "Wrong Photo Size or Background",
      description: "Passport photos must be exactly 2×2 inches with a white or off-white background. Many local photo shops use wrong specs.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form",
      description: "Missing signatures or using the wrong form type are the #1 reasons for rejection at Richland County acceptance facilities.",
    },
    {
      icon: "ri-money-dollar-circle-line",
      title: "Wrong Payment Amount",
      description: "Fees change frequently. Many applicants show up with incorrect payment and have to reschedule.",
    },
    {
      icon: "ri-calendar-close-line",
      title: "No Proof of Travel",
      description: "Without flight confirmation or travel itinerary, the regional agency will turn you away for emergency appointments.",
    },
    {
      icon: "ri-time-line",
      title: "Waiting Too Long to Start",
      description: "Standard processing takes 8–11 weeks. Start expedited at least 3 weeks before travel.",
    },
    {
      icon: "ri-parent-line",
      title: "Missing Parental Consent for Minors",
      description: "For minors, both parents must appear or submit notarized consent. Don't miss this requirement.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop documents at any UPS location in Mansfield." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document before hand-delivering to the State Department." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Your passport is processed at a U.S. Department of State facility using our registered courier slots." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Mansfield address — trackable every step of the way." },
  ],
  faqs: [
    { q: "Can I get an emergency passport in Mansfield before international travel?", a: "Yes. Fast Passport Center provides emergency passport services in Mansfield for travelers with urgent international flights. Our registered couriers achieve 24–48 hour turnaround without the 5+ hour drive to Chicago." },
    { q: "How fast can I renew my passport in Mansfield?", a: "We offer fast passport renewal in Mansfield in as little as 24–48 hours through our emergency courier service. For less urgent travel, our 3–5 day expedited option provides the best value." },
    { q: "What is the closest passport agency to Mansfield, OH?", a: "The nearest regional passport agency to Mansfield is the Chicago Passport Agency, approximately 350 miles away. For urgent processing without the long drive, Fast Passport Center's registered courier service achieves 24–48 hour turnaround from Mansfield." },
    { q: "Do I need to drive to Chicago for an emergency passport?", a: "No. With Fast Passport Center, you complete everything online and ship your documents overnight. Our couriers handle the in-person delivery to State Department facilities." },
    { q: "Can I expedite a child passport in Mansfield?", a: "Yes. We expedite child passports in Mansfield for minors under 16. Both parents must appear or submit notarized consent, along with the child's birth certificate." },
    { q: "What should I do if I lost my passport before a trip?", a: "Contact Fast Passport Center immediately. We provide lost passport replacement services in Mansfield with DS-64 form guidance. Our emergency courier service can get your replacement passport in 24–48 hours." },
  ],
  photoLocations: [
    { name: "CVS Pharmacy — Mansfield", address: "2040 Park Ave W, Mansfield, OH 44906", hours: "Mon–Sun: 8AM–10PM" },
    { name: "Walgreens — Mansfield", address: "1600 Lexington Ave, Mansfield, OH 44907", hours: "Mon–Sun: 7AM–11PM" },
    { name: "Walmart Supercenter — Mansfield", address: "2485 Possum Run Rd, Mansfield, OH 44903", hours: "Mon–Sun: 6AM–11PM" },
    { name: "FedEx Office — Ontario", address: "2500 W 4th St, Ontario, OH 44906", hours: "Mon–Fri: 8AM–8PM" },
  ],
  dmvLocations: [
    {
      name: "Richland County BMV — Mansfield",
      address: "640 N Mulberry St, Mansfield, OH 44903",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Driver's license and REAL ID services. Appointment strongly recommended.",
      featured: true,
    },
    {
      name: "Ontario BMV Deputy Registrar",
      address: "2530 Park Ave W, Ontario, OH 44906",
      hours: "Mon–Fri: 9AM–5PM",
      note: "Alternative for west-side residents. REAL ID available.",
      featured: false,
    },
  ],
  airports: [
    {
      code: "CAK",
      name: "Akron-Canton Regional Airport",
      distance: "65 miles east of Mansfield",
      address: "5400 Lauby Rd NW, North Canton, OH 44720",
      note: "Nearest major airport for most Mansfield travelers. Domestic routes to major hubs.",
      flightUrl: "https://akroncantonairport.com/",
      flightLabel: "CAK Airport",
      featured: true,
    },
    {
      code: "CMH",
      name: "John Glenn Columbus International Airport",
      distance: "75 miles south of Mansfield",
      address: "4600 International Gateway, Columbus, OH 43219",
      note: "Larger hub with more domestic and international routes. Good option for Mansfield area travelers.",
      flightUrl: "https://www.flycmh.com/",
      flightLabel: "Columbus Airport",
      featured: false,
    },
    {
      code: "CLE",
      name: "Cleveland Hopkins International Airport",
      distance: "80 miles north of Mansfield",
      address: "5300 Riverside Dr, Cleveland, OH 44135",
      note: "Major hub with international routes. Accessible via I-71 north.",
      flightUrl: "https://www.clevelandairport.com/",
      flightLabel: "Cleveland Airport",
      featured: false,
    },
  ],
  vitalRecordsIcon: "ri-heart-pulse-line",
};